import { Twitter, Linkedin, Github, Mail } from "lucide-react";
import Logo from "./Logo";

const COLS = [
    {
        title: "Product",
        links: ["Multi-Currency Accounts", "Import Payments", "Export Collections", "API Access", "Bulk Payments"],
    },
    {
        title: "Compliance",
        links: ["RBI Framework", "EDPMS / IDPMS", "FIRA / FIRC", "15CA / 15CB", "Audit Reports"],
    },
    {
        title: "Resources",
        links: ["Documentation", "FX Calculator", "Corridor Guide", "Pricing", "Customer Stories"],
    },
    {
        title: "Company",
        links: ["About", "Careers", "Security", "Privacy Policy", "Terms"],
    },
];

export default function Footer() {
    return (
        <footer className="bg-[#03100C] text-zinc-300 pt-20 pb-10 px-4 md:px-8 border-t border-white/5">
            <div className="mx-auto max-w-7xl">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <Logo variant="dark" />
                        <p className="mt-5 text-sm text-zinc-400 max-w-xs leading-relaxed">
                            Cross-border payments infrastructure built for Indian businesses.
                            Faster, cheaper, transparent international payments — without hidden
                            bank spreads.
                        </p>
                        <div className="mt-6 flex items-center gap-2">
                            {[
                                { icon: Twitter, label: "Twitter" },
                                { icon: Linkedin, label: "LinkedIn" },
                                { icon: Github, label: "GitHub" },
                                { icon: Mail, label: "Email" },
                            ].map((s) => (
                                <a
                                    key={s.label}
                                    href={s.label === "Email" ? "mailto:Info@truopay.com" : "#"}
                                    aria-label={s.label}
                                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                                    className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 hover:bg-white/5 transition-colors"
                                >
                                    <s.icon className="h-4 w-4" />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="md:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
                        {COLS.map((col) => (
                            <div key={col.title}>
                                <div className="text-xs tracking-[0.25em] uppercase font-bold text-emerald-300">
                                    {col.title}
                                </div>
                                <ul className="mt-4 space-y-2.5">
                                    {col.links.map((l) => (
                                        <li key={l}>
                                            <a
                                                href="#"
                                                className="text-sm text-zinc-400 hover:text-white transition-colors"
                                            >
                                                {l}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-14 pt-6 border-t border-white/5 grid md:grid-cols-2 gap-6 items-center">
                    <p className="text-xs text-zinc-500 max-w-2xl leading-relaxed">
                        TruoPay is in the process of applying for an RBI PA-CB authorization and
                        currently partners with regulated AD-I banks for all cross-border
                        settlements. Rates shown on this site are indicative; production quotes
                        reflect live interbank pricing at the time of trade.
                    </p>
                    <div className="md:text-right text-xs text-zinc-500">
                        © {new Date().getFullYear()} TruoPay. All rights reserved.
                    </div>
                </div>
            </div>
        </footer>
    );
}
